export default __webpack_public_path__ + "static/media/artwork-banner-2.74e8daad.jpg";